import { IntentKind, makeIntentGuard } from '@jet-app/music-classical/intents';
import type { Intent } from '@jet/environment/dispatching';

export interface TrackMetadataIntent extends Intent<any> {
    $kind: IntentKind.TRACK_METADATA_INTENT;
    trackIds: string[];
    queue: Array<unknown>;
    payload?: any;
}

export const isTrackMetadataIntent = makeIntentGuard<TrackMetadataIntent>(
    IntentKind.TRACK_METADATA_INTENT,
);

export function makeTrackMetadataIntent(
    options: Omit<TrackMetadataIntent, '$kind'>,
): TrackMetadataIntent {
    return {
        ...options,
        $kind: IntentKind.TRACK_METADATA_INTENT,
    };
}
